import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.001 11.333h-12a.666.666 0 1 0 0 1.334h12a.667.667 0 0 0 0-1.334m0-2.666H7.334a.667.667 0 1 0 0 1.333h6.667a.667.667 0 0 0 0-1.333M1.488 9.54a.667.667 0 0 0 .94.08L3.76 8.513a.667.667 0 0 0 0-1.026L2.428 6.38a.67.67 0 0 0-.71-.097.667.667 0 0 0-.144 1.117l.72.6-.72.6a.667.667 0 0 0-.086.94M2 4.667h12a.667.667 0 0 0 0-1.334h-12a.667.667 0 0 0 0 1.334m12 1.333H7.334a.667.667 0 0 0 0 1.333h6.667a.667.667 0 0 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })